import { ROUTE } from '../../../routes';
export const GoBackAction = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.KYC_STEPPER);
};
export const triggerAction = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.KYC_DOCUMENTS_UPLOAD_POA_MANUAL, {});
};
export const digilockerAction = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, {});
};
